import React from 'react';
import { Modal, Button, Form, Row, Col, Container } from 'react-bootstrap';
import { useState, useRef, useEffect } from 'react';
import Swal from 'sweetalert2';
import { downloadHistory } from '../../../services/CommonService';
import jsPDF from "jspdf";




export default function BannerModal({ show, onClose, data }) {
  const initialFormState = {
    name: '',
    phone: '',
    email: '',
    reason_for_download: '',
  };
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    reason_for_download: '',
  });
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [resonData, setReasonData] = useState([]);
  const [modalCheckboxChecked, setModalCheckboxChecked] = useState(false);

  // Show Modal
  useEffect(() => {
    if (show) {
      setFormData(initialFormState); // Reset form
      const resonDa = JSON.parse(localStorage.getItem('lookup'));
      const getUserData = JSON.parse(localStorage.getItem('usercre'));
      setReasonData(resonDa || []);
      if (getUserData) {
        setFormData((prevData) => ({
          ...prevData,
          name: getUserData.name || '',
          email: getUserData.email || '',
          phone: getUserData.phone || '',
          id: getUserData.id
        }));
      } else {
        setFormData({
          name: '',
          email: '',
          phone: '',
          reason_for_download: '',
        });
      }
    }
  }, [show, data]);

  const handleLinkClick = (e) => {
    e.preventDefault(); // Prevent normal link behavior
    setShowModal(true); // Show modal
  };

  const handleAgree = () => {
    setTermsAccepted(true);
    setShowModal(false);
  };


  // form change control
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'phone') {
      if (!/^\d{0,10}$/.test(value)) return;
      if (value.length > 0 && !/^[6-9]/.test(value)) return;
    }

    if (name === 'name') {
      if (!/^[A-Za-z\s]{0,30}$/.test(value)) return;
    }
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Close Modal
  const handleClose = () => {
    setFormData(initialFormState);
    onClose(); // Close modal
    setShowModal(false);
  };


  // Submit Upload Form
  const handleSubmit = async (event) => {
    event.preventDefault();

    const { name, phone, email, reason_for_download, id } = formData;

    if (!name || !phone || !email || !reason_for_download) {
      alert("Please fill in all the fields.");
      return;
    }
    if (!termsAccepted) {
      alert("Please accept the terms and conditions.");
      return;
    }

    const publicationform = new FormData();
    publicationform.append('user_id', id || '');
    publicationform.append('publications_id', data.data.id);
    publicationform.append('created_by', '');
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== null) {
        publicationform.append(key, formData[key]);
      }
    });
    try {
      let response;
      if (data) {
        response = await downloadHistory(publicationform);

        const doc = new jsPDF();

        // Title
        doc.setFontSize(18);
        doc.setFont("helvetica", "bold");
        doc.text(" Document Details", 20, 20);

        // Style
        doc.setFontSize(12);
        doc.setFont("helvetica", "normal");

        let y = 30;
        const lineHeight = 8;
        const excludeKeys = ["id", "created_at", "updated_at", "is_deleted", "state", "district", "country", "typology"];
        const labelStyle = { font: "helvetica", style: "bold" };
        const valueStyle = { font: "helvetica", style: "normal" };

        // Draw each key-value pair
        Object.entries(data?.data).forEach(([key, value]) => {
          if (!excludeKeys.includes(key)) {
            if (value === null || value === undefined) value = "—";
            const formattedKey = capitalizeFirstChar(key);

            doc.setFont(labelStyle.font, labelStyle.style);
            doc.text(`${formattedKey}:`, 20, y);
            doc.setFont(valueStyle.font, valueStyle.style);
            doc.text(`${value}`, 60, y);
            y += lineHeight;
          }
        });

        // Optional: draw border around content
        doc.setDrawColor(150);
        doc.rect(15, 15, 180, y - 20 + 10); // x, y, width, height

        // Open in new tab
        const pdfBlobUrl = doc.output('bloburl');
        window.open(pdfBlobUrl, '_blank');


      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err?.response?.data?.message || err?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }

  };

  function capitalizeFirstChar(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // All View Here
  return (
    <>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: "#FFA500", color: "#000", fontWeight: "bold" }}
        >
          {/* <p>{{data}}</p> */}
          <Modal.Title>{data?.data?.title}</Modal.Title>
        </Modal.Header>

        <Modal.Body style={{}}>
          <Container>
            <Form onSubmit={handleSubmit}>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="formName">
                    <Form.Label style={{
                      fontSize: 'medium',
                      fontWeight: '600'
                    }}>Name<span class="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder="Enter name"
                      value={formData.name}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ed9003',
                        color: '#000',
                        padding: '5px',
                        fontSize: 'smaller'
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formPhone">
                    <Form.Label style={{
                      fontSize: 'medium',
                      fontWeight: '600'
                    }}>Phone<span class="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="tel"
                      name="phone"
                      placeholder="Enter phone"
                      value={formData.phone}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ed9003',
                        color: '#000',
                        padding: '5px',
                        fontSize: 'smaller'
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group controlId="formEmail">
                    <Form.Label style={{
                      fontSize: 'medium',
                      fontWeight: '600'
                    }}>Email<span class="text-danger">*</span></Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      placeholder="Enter email"
                      value={formData.email}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ed9003',
                        color: '#000',
                        padding: '5px',
                        fontSize: 'smaller'
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formReason" className="mb-4">
                    <Form.Label style={{
                      fontSize: 'medium',
                      fontWeight: '600'
                    }}>Reason for download<span class="text-danger">*</span></Form.Label>

                    <Form.Control
                      as="select"
                      name="reason_for_download"
                      value={formData.reason_for_download}
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ed9003',
                        color: '#000',
                        padding: '5px',
                        fontSize: 'smaller'
                      }}
                    >
                      <option value="">Select Reason</option>
                      {resonData.map((typo) => (
                        typo.Flag == 5 ? (
                          <option key={typo.id_mstlookup} value={typo.id_mstlookup}>
                            {typo.LookupValue}
                          </option>
                        ) : null
                      ))}
                    </Form.Control>
                  </Form.Group>

                </Col>
              </Row>
              <Form.Group controlId="formTerms" className="mt-3">
                <Form.Check
                  type="checkbox"
                  label={
                    <>
                      <a href="#" onClick={handleLinkClick}>
                        Click to read and acknowledge the terms & Conditions.
                      </a>
                    </>
                  }
                  checked={termsAccepted}
                  onChange={() => {
                    if (!termsAccepted) setShowModal(true);
                    else setTermsAccepted(false); // Uncheck directly
                  }}
                  style={{ fontSize: 'smaller' }}
                />
              </Form.Group>
              <div className="text-end mt-3">
                <Button variant="primary" type="submit" disabled={
                  !termsAccepted ||
                  !formData.name.trim() ||
                  !formData.phone.trim() ||
                  !formData.email.trim() ||
                  !formData.reason_for_download.trim()
                }>
                  Download
                </Button>{" "}
                <Button variant="secondary" onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            </Form>
          </Container>
        </Modal.Body>
      </Modal>
      {/* <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton style={{ backgroundColor: "#FFA500", color: "#000", fontWeight: "bold" }}>
          <Modal.Title>Terms and Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Here you can show the full terms and conditions text.</p>
          <p>You can make this scrollable or styled as needed.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleAgree}>
            I Agree
          </Button>
        </Modal.Footer>
      </Modal> */}
      {showModal && (
        <div
          style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '90%',
              maxWidth: '1000px',
              textAlign: 'center',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)'
            }}
          >
            <h2>Terms & Conditions</h2>
            <div style={{ maxHeight: '300px', overflowY: 'auto', textAlign: 'left', marginTop: '15px' }}>
              <p><strong>By proceeding to download this report, I hereby agree to the following terms and conditions:</strong></p>

              <ol>
                <li>
                  <strong>Proper Usage:</strong><br />
                  I understand that the report I am downloading is intended for educational, informational, or non-commercial purposes only (unless explicitly stated otherwise). I agree to use the content responsibly and in accordance with its intended use.
                </li>
                <li>
                  <strong>Respect for Intellectual Property:</strong><br />
                  I acknowledge that all intellectual property rights of the content remain with the original creators or the organization providing the report. I will not reproduce, modify, or distribute the report or any part of it without proper attribution or prior written permission.
                </li>
                <li>
                  <strong>License Terms:</strong><br />
                  I agree to honor and comply with all the terms and conditions specified under the report’s license (e.g., Creative Commons, internal organizational policy, etc.).
                </li>
                <li>
                  <strong>Attribution:</strong><br />
                  I will give appropriate credit to the authors or the organization, provide a link to the license (if applicable), and indicate if any changes were made, as per the guidelines.
                </li>
                <li>
                  <strong>No Misuse:</strong><br />
                  I will not use the report or its content for unlawful, misleading, defamatory, or harmful purposes. I will not use the information in any way that could damage the reputation or credibility of the organization or its partners.
                </li>
                <li>
                  <strong>Confidentiality (if applicable):</strong><br />
                  If the report contains any sensitive or restricted information, I agree to maintain its confidentiality and not share it with unauthorized individuals.
                </li>
                <li>
                  <strong>Acknowledgement:</strong><br />
                  By downloading the report, I confirm that I have read, understood, and agreed to the above terms.
                </li>
              </ol>
            </div>

            {/* Checkbox inside Modal */}
            <div style={{ marginTop: '15px', textAlign: 'left' }}>
              <label style={{ fontSize: '14px' }}>
                <input
                  type="checkbox"
                  checked={modalCheckboxChecked}
                  onChange={(e) => setModalCheckboxChecked(e.target.checked)}
                  style={{ marginRight: '8px' }}
                />
                I have read and agree to the Terms & Conditions.
              </label>
            </div>

            {/* Modal Buttons */}
            <div style={{ marginTop: '20px' }}>
              <button
                onClick={() => {
                  setTermsAccepted(true);
                  setShowModal(false);
                  setModalCheckboxChecked(false); // Reset for next time
                }}
                disabled={!modalCheckboxChecked}
                style={{
                  padding: '10px 20px',
                  backgroundColor: modalCheckboxChecked ? '#007bff' : '#ccc',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: modalCheckboxChecked ? 'pointer' : 'not-allowed',
                  marginRight: '10px'
                }}
              >
                Accept
              </button>
              <button
                onClick={() => {
                  setShowModal(false);
                  setModalCheckboxChecked(false); // Optional reset
                }}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#ccc',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer'
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
